import React, { Component } from 'react';
import { Accordion, Icon } from 'semantic-ui-react';

class BlogosphereRawData extends Component {
  state = { activeIndex: -1 }

  handleClick = (e, titleProps) => {
    const { index } = titleProps
    const { activeIndex } = this.state
    const newIndex = activeIndex === index ? -1 : index

    this.setState({ activeIndex: newIndex })
  }

  render() {
    const { activeIndex } = this.state;
    const { details } = this.props;
    return (
      <Accordion fluid styled>
        <Accordion.Title active={activeIndex === 0} index={0} onClick={this.handleClick}>
          <Icon name="dropdown" />
          Blogosphere raw data
        </Accordion.Title>
        <Accordion.Content active={activeIndex === 0}>
          <pre>
            { JSON.stringify(details, null, 2) }
          </pre>
        </Accordion.Content>

      </Accordion>
    );
  }
}

export default BlogosphereRawData;



/** WEBPACK FOOTER **
 ** ./src/components/blogosphere-raw-data/index.js
 **/